<template>
    <div>
      <div class="head">
        <van-tabs @click="onClick" v-model="activeName">
          <van-tab title="同步课程" name="5"><slot></slot></van-tab>
          <van-tab title="知识点课程" name="233"><slot></slot></van-tab>
          <van-tab title="专题课程" name="232"><slot></slot></van-tab>
        </van-tabs>
      </div>
    </div> 
</template>

<script>
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import { Toast } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);

import classlist from '@/components/ClassList'
import VueEvent from '../model/VueEvent';
import URL from '../api/index'
export default {
  components:{

  },
  data() {
    return {
      activeName: 'a'
    }
  },
  watch:{
    activeName(val, newval) {
      // console.log(val)
      // console.log(newval)
    },
  },
  mounted(){
    var that = this
    VueEvent.$on('num',function(data){
      console.log(data)
      that.activeName = data
      console.log(that.activeName);
    })
  },
  methods:{
    onClick(name, title) {
        VueEvent.$emit('topid',name)
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 800px) {
  .head{
    width: 800PX;
    line-height: 45px;
    text-align: center;
    font-size: 14px;
    position: fixed;
    top: 0;
    z-index: 2;
    background-color: #fff;
  }
}
@media screen and (min-width: 320px) and (max-width: 799px) {
  .head{
    width: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 14px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabsApp.vue